__turbopack_context__.v({
  "blue": "XSEbYG_blue",
  "button": "XSEbYG_button",
  "destructive": "XSEbYG_destructive",
  "disabled": "XSEbYG_disabled",
  "icon": "XSEbYG_icon",
  "isLoading": "XSEbYG_isLoading",
  "lds-ring": "XSEbYG_lds-ring",
  "ldsRing": "XSEbYG_ldsRing",
  "link": "XSEbYG_link",
  "primary": "XSEbYG_primary",
  "purple": "XSEbYG_purple",
  "secondary": "XSEbYG_secondary",
  "small": "XSEbYG_small",
  "tertiary": "XSEbYG_tertiary",
  "wide": "XSEbYG_wide",
});
